
document.addEventListener('DOMContentLoaded', () => {
  const tabSections = document.querySelectorAll('[data-program-tabs]');

  tabSections.forEach((section) => {
    const buttons = Array.from(section.querySelectorAll('[data-tab-button]'));
    const panels = Array.from(section.querySelectorAll('[data-tab-panel]'));

    const activateTab = (tabKey) => {
      buttons.forEach((button) => {
        const isActive = button.getAttribute('data-tab-button') === tabKey;

        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach((panel) => {
        const isActive = panel.getAttribute('data-tab-panel') === tabKey;

        panel.classList.toggle('is-active', isActive);

        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        activateTab(button.getAttribute('data-tab-button'));
      });
    });
  });
});